// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-body
{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.aiiif-root * {
    box-sizing: border-box;
    scrollbar-width: thin;
}

.aiiif-root {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.aiiif-folder-and-info {
    padding-top: 18px;
    display: flex;
    flex-direction: row;
}

.aiiif-folder-view {
    display: flex;
    flex-wrap: wrap;
}

.aiiif-folder-view-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;
}

.aiiif-folder-view-container h1 {
    font-size: 1.4em;
}

.aiiif-folder-view-container > div {
    overflow-y: auto;
    padding: 8px;
}

h1 {
    margin-top: 0;
}

h3 {
    margin: 0 0 20px 0 !important;
}

.aiiif-provider-logo {
    max-width: 70%;
    display: block;
    margin: 30px 0 20px;
}

.aiiif-fullpage {
    height: 100% !important;
}

/* wired firefox workaround */
.aiiif-content > .aiiif-b {
    height: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uDAAuD;IACvD,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,WAAW;AACf","sourcesContent":[".aiiif-body\n{\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n}\n\n.aiiif-root * {\n    box-sizing: border-box;\n    scrollbar-width: thin;\n}\n\n.aiiif-root {\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.aiiif-folder-and-info {\n    padding-top: 18px;\n    display: flex;\n    flex-direction: row;\n}\n\n.aiiif-folder-view {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.aiiif-folder-view-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: white;\n}\n\n.aiiif-folder-view-container h1 {\n    font-size: 1.4em;\n}\n\n.aiiif-folder-view-container > div {\n    overflow-y: auto;\n    padding: 8px;\n}\n\nh1 {\n    margin-top: 0;\n}\n\nh3 {\n    margin: 0 0 20px 0 !important;\n}\n\n.aiiif-provider-logo {\n    max-width: 70%;\n    display: block;\n    margin: 30px 0 20px;\n}\n\n.aiiif-fullpage {\n    height: 100% !important;\n}\n\n/* wired firefox workaround */\n.aiiif-content > .aiiif-b {\n    height: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
